import { ItemType, MenuItemType } from 'antd/es/menu/interface'
import MainContentLayout from '../../components/MainContentLayout'
import { PlaylistsRouter, TracksRouter } from '../../utils/routes/MusicRoutes'
import { ClientsRouter } from '../../utils/routes/UsersRoutes'

const menu: ItemType<MenuItemType>[] = [
  {
    label: 'All',
    key: 'all',
  },
  {
    label: 'New',
    key: 'new',
  },
]

export default function Clients() {
  return (
    <MainContentLayout
      navigationHeader={{
        headerMenu: menu,
        navigationPrefix: '/users/clients/',
      }}
    >
      <ClientsRouter />
    </MainContentLayout>
  )
}
